import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanDeactivate } from '@angular/router';
import { UtilityService } from '../utility.service';
export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuardService  implements CanDeactivate<CanComponentDeactivate> {
constructor(private us: UtilityService) {}
  canDeactivate(component: CanComponentDeactivate) : Observable<boolean> | Promise<boolean> | boolean {
    let candeactivate = component.canDeactivate ? component.canDeactivate() : true;
     if (!candeactivate) {
      return this.us.Confirmation('You have unsaved changes. Are you sure you want to leave this page?','Confirmation')
    }
    return true
  }
}
